"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

require("core-js/modules/es6.array.sort");

var _v = _interopRequireDefault(require("./admin-dashboard/v0"));

var _v2 = _interopRequireDefault(require("./admin-dashboard/v1"));

var _v3 = _interopRequireDefault(require("./admin-dashboard/v2"));

var _v4 = _interopRequireDefault(require("./admin-dashboard/v3"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "AdminDashboard",
  components: {
    V0: _v.default,
    V1: _v2.default,
    V2: _v3.default,
    V3: _v4.default
  },
  data: function data() {
    return {
      smsColor: "#91cc75",
      agentsColor: "#5470c6",
      paymentColor: "#fac858",
      sevenDaysColor: "#73c0de",
      cardData: {
        ReceiveFail: 3,
        Deposited: 0,
        RechargeSuccess: 3,
        RechargeFail: 4,
        Refund: 0,
        SubmitFail: 1,
        ReceiveSuccess: 1,
        totalCountQueryApi: 14,
        processTotalSumMoneyFrom: "0.100265",
        SubmitSuccess: 2,
        payAmountSortedByCurrencyList: [{
          sumMoneyTo: 0,
          moneyTypeTo: "CNY",
          processSumMoneyTo: "0.681735"
        }]
      },
      channelDate: "2021-07-01",
      topRate: [],
      topRatePercent: [],
      topRateLabels: [],
      bottomRate: [],
      bottomRatePercent: [],
      bottomRateLabels: [],
      topOrgs: [],
      topAgents: [],
      loading: false,
      sevenDaysNotEmpty: true,
      successDate: "",
      failDate: "",
      numberOfDecimal: 2,
      submitSuccessRate: [// {
        //   date: "2021-08-03",
        //   totalConsumeAmount: "200000",
        // },
        // {
        //   date: "2021-08-02",
        //   totalConsumeAmount: "666660",
        // },
        // {
        //   date: "2021-08-01",
        //   totalConsumeAmount: "100000",
        // },
        // {
        //   date: "2021-07-31",
        //   totalConsumeAmount: "100000",
        // },
        // {
        //   date: "2021-07-30",
        //   totalConsumeAmount: "700000",
        // },
        // {
        //   date: "2021-07-29",
        //   totalConsumeAmount: "220001",
        // },
        // {
        //   date: "2021-07-28",
        //   totalConsumeAmount: "300000",
        // },
      ],
      highestSuccessRate: [// {
        //   moneyTypeTo: "HKD",
        //   processSumMoneyTo: "810000",
        // },
        // {
        //   moneyTypeTo: "USD",
        //   processSumMoneyTo: "400000",
        // },
        // {
        //   moneyTypeTo: "KR",
        //   processSumMoneyTo: "200000",
        // },
        // {
        //   moneyTypeTo: "CN",
        //   processSumMoneyTo: "100000",
        // },
      ],
      highestSMS: [// {
        //   orgName: "Organization1",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 22400,
        // },
        // {
        //   orgName: "Organization2",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 12000,
        // },
        // {
        //   orgName: "Organization3",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 72000,
        // },
        // {
        //   orgName: "Organization4",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 52000,
        // },
        // {
        //   orgName: "Organization5",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 92000,
        // },
        // {
        //   orgName: "Organization6",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 22000,
        // },
        // {
        //   orgName: "Organization7",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 12000,
        // },
        // {
        //   orgName: "Organization8",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 32000,
        // },
        // {
        //   orgName: "Organization9",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 72000,
        // },
        // {
        //   orgName: "Organization10",
        //   orgCode: "20210707095540ILRT",
        //   totalConsumeAmount: 42000,
        // },
      ],
      agentsHighestRecharge: [// {
        //   agentId: 121,
        //   agentName: "Agents1",
        //   totalConsumeAmount: 600000,
        // },
        // {
        //   agentId: 122,
        //   agentName: "Agents2",
        //   totalConsumeAmount: 200000,
        // },
        // {
        //   agentId: 123,
        //   agentName: "Agents3",
        //   totalConsumeAmount: 200000,
        // },
        // {
        //   agentId: 124,
        //   agentName: "Agents4",
        //   totalConsumeAmount: 120000,
        // },
        // {
        //   agentId: 125,
        //   agentName: "Agents5",
        //   totalConsumeAmount: 400000,
        // },
        // {
        //   agentId: 126,
        //   agentName: "Agents6",
        //   totalConsumeAmount: 301000,
        // },
        // {
        //   agentId: 127,
        //   agentName: "Agents7",
        //   totalConsumeAmount: 100000,
        // },
        // {
        //   agentId: 128,
        //   agentName: "Agents8",
        //   totalConsumeAmount: 500000,
        // },
        // {
        //   agentId: 129,
        //   agentName: "Agents9",
        //   totalConsumeAmount: 300000,
        // },
        // {
        //   agentId: 1210,
        //   agentName: "Agents10",
        //   totalConsumeAmount: 200700,
        // },
      ],
      mostPaymentYesterday: [// {
        //   ChannelName: "VMP_1",
        //   ChannelId: 1,
        //   totalConsumeAmount: "220000",
        // },
        // {
        //   ChannelName: "VMP_2",
        //   ChannelId: 2,
        //   totalConsumeAmount: "210000",
        // },
        // {
        //   ChannelName: "VMP_3",
        //   ChannelId: 3,
        //   totalConsumeAmount: "429000",
        // },
        // {
        //   ChannelName: "VMP_4",
        //   ChannelId: 4,
        //   totalConsumeAmount: "120000",
        // },
        // {
        //   ChannelName: "VMP_5",
        //   ChannelId: 5,
        //   totalConsumeAmount: "920000",
        // },
        //
        // {
        //   ChannelName: "VMP_6",
        //   ChannelId: 6,
        //   totalConsumeAmount: "520000",
        // },
        // {
        //   ChannelName: "VMP_7",
        //   ChannelId: 7,
        //   totalConsumeAmount: "720000",
        // },
        // {
        //   ChannelName: "VMP_8",
        //   ChannelId: 8,
        //   totalConsumeAmount: "620000",
        // },
        // {
        //   ChannelName: "VMP_9",
        //   ChannelId: 9,
        //   totalConsumeAmount: "820000",
        // },
        // {
        //   ChannelName: "VMP_10",
        //   ChannelId: 10,
        //   totalConsumeAmount: "420000",
        // },
      ],
      sortSms: [],
      sortAgents: [],
      sortPaymentYesterday: []
    };
  },
  created: function created() {
    this.getNumberOfDecimal();
    this.fetchYesterdayData();
    this.fetchSevenDays();
    this.fetchTopAgents();
    this.fetchTopChannels();
    this.fetchTopOrgs();
    this.sortSmsList();
    this.sortAgentsList();
    this.sortPaymentYesterdayList();
    this.fetchPayAmountSortedByCurrency();
  },
  updated: function updated() {
    if (this.sevenDaysNotEmpty) this.$refs.dashboard.$refs.lineChart.initChart();
  },
  computed: {
    currentVersion: function currentVersion() {
      return "V".concat(this.$store.getters.platform);
    },
    //Submit Success Rate Latest Seven Days
    lineGraphLabel: function lineGraphLabel() {
      var dateList = this.submitSuccessRate.map(function (item) {
        return item.date;
      });
      return dateList;
    },
    sevenDays: function sevenDays() {
      var amountList = this.submitSuccessRate.map(function (item) {
        return item.totalConsumeAmount;
      });
      return amountList;
    },
    //Highest Channels According to Success Rate
    channelLabels: function channelLabels() {
      var moneyType = this.highestSuccessRate.map(function (item) {
        return item.moneyTypeTo;
      });
      return moneyType;
    },
    channelValues: function channelValues() {
      var processMoney = this.highestSuccessRate.map(function (item) {
        return item.processSumMoneyTo;
      });
      return processMoney;
    },
    //Highest SMS Count Organization
    smsCountValues: function smsCountValues() {
      var newHighestSMS = this.highestSMS.map(function (item) {
        var _object = {};
        _object.name = item.orgName;
        _object.value = item.totalConsumeAmount;
        return _object;
      });
      return newHighestSMS;
    },
    // agentsLabels() {
    //   const agentName = this.sortAgents.map((item) => {
    //     return item.agentName;
    //   });
    //   return agentName;
    // },
    //Agents with Highest Recharge
    agentsValues: function agentsValues() {
      // const totalConsumeAmount = this.sortAgents.map((item) => {
      //   return item.totalConsumeAmount;
      // });
      // return totalConsumeAmount;
      var newAgents = this.agentsHighestRecharge.map(function (item) {
        var object = {
          name: item.agentName,
          value: item.totalConsumeAmount
        };
        return object;
      });
      return newAgents;
    },
    // agentsValues() {
    //   const newAgents = this.agentsHighestRecharge.map((item) => {
    //     const _item = {};
    //     _item.value = item.totalConsumeAmount;
    //     _item.name = item.agentName;
    //   });
    //   return newAgents
    // },
    //The Most Payment Yesterday
    paymentYesterdayLabels: function paymentYesterdayLabels() {
      var ChannelName = this.mostPaymentYesterday.map(function (item) {
        return item.ChannelName;
      });
      return ChannelName;
    },
    paymentYesterdayValues: function paymentYesterdayValues() {
      var totalConsumeAmount = this.mostPaymentYesterday.map(function (item) {
        return item.totalConsumeAmount;
      });
      return totalConsumeAmount;
    }
  },
  methods: {
    //sort sms count
    sortSmsList: function sortSmsList() {
      var _list = this.highestSMS.sort(function (min, max) {
        return min.totalConsumeAmount - max.totalConsumeAmount;
      }).reverse();

      this.sortSms = _list;
    },
    //sort Agents list
    sortAgentsList: function sortAgentsList() {
      var _list = this.agentsHighestRecharge.sort(function (min, max) {
        return min.totalConsumeAmount - max.totalConsumeAmount;
      }).reverse();

      this.sortAgents = _list;
    },
    //sort payment yesterday list
    sortPaymentYesterdayList: function sortPaymentYesterdayList() {
      var _list = this.mostPaymentYesterday.sort(function (min, max) {
        return min.totalConsumeAmount - max.totalConsumeAmount;
      }).reverse();

      this.sortPaymentYesterday = _list;
    },
    fetchYesterdayData: function fetchYesterdayData() {
      var _this = this;

      _httpUtils.default.get("HomeData", "getTodayData", null, null).then(function (res) {
        _this.cardData = (0, _objectSpread2.default)({}, res);
        _this.loading = false;
      }).catch(function (err) {
        console.log(err);
      });
    },
    fetchPayAmountSortedByCurrency: function fetchPayAmountSortedByCurrency() {
      var _this2 = this;

      var _this = this;

      _httpUtils.default.get("HomeData", "getPayAmountSortedByCurrencyType", null, null, null).then(function (res) {
        _this2.highestSuccessRate = res; // _this.$nextTick(() =>
        //   _this.$refs.dashboard.$refs.barChart.initChart()
        // );
      }).catch(function (err) {
        console.log(err);
      });
    },
    fetchSevenDays: function fetchSevenDays() {
      var _this3 = this;

      var _this = this;

      _httpUtils.default.get("HomeData", "getTotalPayAmountForResentSevenDays", null, null, null).then(function (res) {
        _this3.submitSuccessRate = res; // console.log("data：" + this.submitSuccessRate);
        // _this.$nextTick(() => _this.$refs.dashboard.$refs.lineChart.initChart());
      }).catch(function (err) {
        console.log(err);
      });
    },
    fetchTopOrgs: function fetchTopOrgs() {
      var _this4 = this;

      var _this = this;

      _httpUtils.default.get("HomeData", "getTopTenOrganizationsWithTheMostPaymentYesterday", null, null, null).then(function (res) {
        _this4.highestSMS = res; // _this.$nextTick(() => {
        //   try {
        //     _this.$refs.dashboard.$refs.pieChart.initChart();
        //   } catch (err) {
        //     console.log(err)
        //   }
        // });
      }).catch(function (err) {
        console.log(err);
      });
    },
    fetchTopAgents: function fetchTopAgents() {
      var _this5 = this;

      var _this = this;

      _httpUtils.default.get("HomeData", "getTopTenAgentsWithTheMostPaymentYesterday", null, null, null).then(function (res) {
        _this5.agentsHighestRecharge = res; // _this.$nextTick(() => _this.$refs.dashboard.$refs.pieChart.initChart());
      }).catch(function (err) {
        console.log(err);
      });
    },
    fetchTopChannels: function fetchTopChannels() {
      var _this6 = this;

      var _this = this;

      _httpUtils.default.get("HomeData", "getTopTenChannelsWithTheMostPaymentYesterday", null, null, null).then(function (res) {
        _this6.mostPaymentYesterday = res; // _this.$nextTick(() => _this.$refs.dashboard.$refs.barChart.initChart());
      }).catch(function (err) {
        console.log(err);
      });
    },
    getNumberOfDecimal: function getNumberOfDecimal() {
      var _this7 = this;

      _httpUtils.default.post("agentCost", "getNumberOfDecimal", {}, null).then(function (res) {
        _this7.numberOfDecimal = res.data.numberOfDecimal;
      }).catch(function (err) {
        _this7.$message({
          message: err.message,
          type: "error"
        });
      });
    }
  }
};
exports.default = _default;